import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import DocumentSectionIcon from '@/svg-icons/documents-circle';

const FilesToSignSection = ({ documents }) => {
  if (!documents || documents.length === 0) return null;

  const DocumentIcon = props => (
    <svg 
      {...props} 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      className={`lucide lucide-file-text ${props.className || ''}`}
    >
      <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
      <path d="M14 2v4a2 2 0 0 0 2 2h4" />
      <path d="M10 9H8" />
      <path d="M16 13H8" />
      <path d="M16 17H8" />
    </svg>
  );

  return (
    <div className="w-full">
      <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
        <DocumentSectionIcon 
          viewBox="0 0 34.016 34.016" 
          className="text-gray-700 mr-2 w-6 h-6 shrink-0" 
        />
        <FormattedMessage id="documents" />
      </div>

      <div className="flex flex-col text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]">
        {documents.map((document) => (
          <div key={document.id} className="flex items-center gap-[0.8vw] py-[0.4vw]">
            <DocumentIcon className="w-5 h-5 text-[#858585] shrink-0" />
            <p className="m-0 break-words" data-cy="order-details-document-name">
              {document.name}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

FilesToSignSection.propTypes = {
  documents: PropTypes.array.isRequired,
};

export default FilesToSignSection;
